import React from 'react'
export default (rowSpan, scoreItemRender, moduleContent) => [
  {
    name: "moduleContent",
    title: "模拟场景",
    dataIndex: "moduleContent",
    tableItem: {
      width: '15%',
      render: (value, row, index) => {
        const obj = {
          children: <span dangerouslySetInnerHTML={{__html: moduleContent}}></span>,
          props: {
            style : {
              fontSize: 16
            }
          },
        };

        if (index === 0) {
          obj.props.rowSpan = rowSpan;
          obj.props.style = {
            fontSize: 16,
            verticalAlign: 'top',
          }
        }else{
          obj.props.rowSpan = 0
        }
        return obj;
      }
    }
  },
  {
    name: "num",
    title: "序号",
    dataIndex: "num",
    tableItem: {
      width: '5%',
      render: (value, row, index) => {
        const obj = {
          children: index + 1,
          props: {
            style : {
              fontSize: 16
            }
          },
        };
        return obj;
      }
    }
  },
  {
    name: "questionName",
    title: "考题",
    dataIndex: "questionName",
    tableItem: {
      width: '35%',
      render: (value, row, index) => {
        const obj = {
          children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
          props: {
            style : {
              fontSize: 16
            }
          },
        };
        return obj;
      }
    }
  },
  {
    name: "questionContent",
    title: "考点",
    dataIndex: "questionContent",
    tableItem: {
      width: '35%',
      render: (value, row, index) => {
        const obj = {
          children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
          props: {
            style : {
              fontSize: 16
            }
          },
        };
        return obj;
      }
    }
  },
  {
    name: "score",
    title: "考点得分",
    dataIndex: "kaodiandefen",
    tableItem: {
      width: '10%',
      render: scoreItemRender
    }
  },
];
